"use client";

import { cn } from "@/lib/utils";

interface SpinnerProps {
  /** Pixel size of the spinner (square). Default 20. */
  size?: number;
  /** Wrapper class — colour the spinner via `text-*` utilities (the arc and track inherit currentColor). */
  className?: string;
  /** Accessible label for screen readers (default "Loading"). */
  label?: string;
}

// Minimal circular spinner: a faint full-circle track behind a thicker arc
// that rotates via Tailwind's built-in `animate-spin`. Inherits
// `currentColor` so a parent `text-*` utility recolours both strokes.
export function Spinner({
  size = 20,
  className,
  label = "Loading",
}: SpinnerProps) {
  return (
    <svg
      role="status"
      aria-label={label}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={cn("shrink-0 animate-spin text-current", className)}
    >
      <circle
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeOpacity="0.18"
      />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
